var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6001 18.5992L13.2001 13.1992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80005 11.4008C4.80005 7.75626 7.75553 4.80078 11.4 4.80078C15.0446 4.80078 18 7.75626 18 11.4008C18 15.0453 15.0446 18.0008 11.4 18.0008C7.75553 18.0008 4.80005 15.0453 4.80005 11.4008ZM14.7837 10.3694C15.0425 10.1411 15.0672 9.74609 14.8388 9.48727C14.6105 9.22844 14.2155 9.20375 13.9567 9.43213L10.8042 12.2137L9.11815 10.6963C8.86158 10.4653 8.4664 10.4861 8.23549 10.7427C8.00458 10.9993 8.02538 11.3945 8.28195 11.6254L10.382 13.5154C10.6179 13.7278 10.9756 13.7295 11.2136 13.5195L14.7837 10.3694Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewers);
export default __webpack_public_path__ + "static/media/reviewers.71a5533d07249fd789d7912ccc074453.svg";
export { ForwardRef as ReactComponent };